module.exports = __webpack_public_path__ + "img/img3.4a2eaa25.jpg";